export const msalConfig = {
  auth: {
    clientId: "f46db7c4-bb17-445a-8cc5-9125edda4e41",
    authority: "https://login.microsoftonline.com/45f26a63-9c71-4681-bde9-7b9a99d6b768",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "User.Read"],
};
